<template>
  <div>
    <div>
      <el-card class="box-card">
        <div style="overflow: hidden;">
          <ul class="list-left">
            <div style="width: 100%;padding: 10px 0;background: #ebebeb;position : sticky;top:0;z-index: 100;">
              <div style="width: 100%;overflow: hidden;">
                <div style="width: 76%;float: left;margin-left:2%;">
                  <el-input clearable size="mini" :placeholder="$t('message.placeholder.input')" @clear="searchLists"
                    @keyup.enter.native="searchLists" v-model="search" class="input-with-select"
                    style="margin:0 20px 0 0">
                    <el-button slot="append" icon="el-icon-search" @click="searchLists"></el-button>
                  </el-input>
                </div>
                <div style="float: left;margin-left:2%;">
                  <el-button type="success" size="mini" icon="el-icon-circle-plus-outline" @click="addForm"></el-button>
                </div>
              </div>

            </div>

            <li v-for="(item, index) in gridOptions.data" :key="item.id" :title="item.name"
              :class="{ isDisable: item.enabled == 0, active: index == num }">
              <span class="list-left-label" @click="dbClick(item, index)">
                {{ item.listTypeName }}
              </span>
              <span style="position: relative;top: -5px;left: 12px;">
                <el-switch v-model="listEnabled[index].value" active-color="#13ce66"
                  @change="listSwitchChange(item, index)">
                  <!-- :disabled="!listEnabled[index].editable" -->
                </el-switch>
              </span>
              <span @click="removeRowEvent(item)">
                <i class="el-icon-delete" style="position: relative;top: -3px;left: 6%;cursor: pointer;"></i>
              </span>
            </li>
          </ul>

          <div class="list-right">
            <router-view :if="listInfoShow" :key="activeDate" @update="updateLists"></router-view>
          </div>

          <!-- <vxe-grid v-bind="gridOptions"  @cell-dblclick="dbClick" :row-style="{height:'56px'}">
            <template v-slot:operate="{ row }">
              <el-button @click="removeRowEvent(row)" type="text" icon="el-icon-delete">{{$t('message.button.delete')}}</el-button> -->

          <!-- <vxe-button icon="el-icon-delete" :title= "$t('message.button.delete')" circle @click="removeRowEvent(row)"></vxe-button> -->
          <!-- <vxe-button icon="el-icon-view" :title= "$t('message.button.check')" circle @click="checkInfo(row)"></vxe-button> -->

          <!-- </template>
</vxe-grid> -->
        </div>
      </el-card>
    </div>
    <!-- <div v-if="addShow"> -->
    <el-dialog :title="$t('message.title.createList')" :visible.sync="addShow">
      <el-form :model="createForm" ref="ruleForm" label-width="200px" class="demo-ruleForm" size="small">
        <el-form-item :label="$t('message.table.name')" prop="name" :rules="nameRule">
          <el-input v-model="createForm.name" :style="input_width"></el-input>
        </el-form-item>

        <el-form-item :label="$t('message.table.type')" required>
          <el-select v-model="createForm.listType" :placeholder="$t('message.placeholder.select')" @change="getListType"
            size="small" style="width:100%">
            <el-option :label="$t('message.table.simple')" value="1"></el-option>
            <el-option :label="$t('message.table.cascade')" value="2"></el-option>
            <el-option :label="$t('message.table.code')" value="4"></el-option>
            <el-option :label="$t('message.table.serialNumber')" value="5"></el-option>
            <el-option :label="$t('message.table.versionNumber')" value="6"></el-option>
            <!-- <el-option :label="$t('message.table.reference')" value="7"></el-option> -->
            <el-option :label="$t('message.table.dynamic')" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('message.table.des')">
          <el-input v-model="createForm.description" :style="input_width"></el-input>
        </el-form-item>

        <el-form-item :label="$t('message.table.status')">
          <el-select v-model="createForm.enabled" :placeholder="$t('message.placeholder.select')" size="small"
            style="width:100%">
            <el-option :label="$t('message.table.enabled')" value="1"></el-option>
            <el-option :label="$t('message.table.disabled')" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="createForm.listType == 4" :label="$t('message.table.codeValueLength')" required
          prop="codeValueLength" :rules="codeValueLengthRule">
          <el-input v-model="createForm.codeValueLength" :style="input_width" @blur="filterNumberLength"></el-input>
        </el-form-item>

        <el-form-item v-if="createForm.listType == 3" :label="$t('message.table.criteria')">
          <el-select v-model="createForm.criteria" :placeholder="$t('message.placeholder.select')" size="small"
            style="width:100%">
            <el-option v-for="item in seekList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item :label= "$t('message.table.displayType')">
          <el-select v-model="createForm.displayType" :placeholder="$t('message.placeholder.select')" size="small" :style="input_width">
            <el-option :label= "$t('message.table.list')" value="1"></el-option>
            <el-option :label= "$t('message.table.search')" value="2"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" @click="submitForm">{{ $t('message.button.createNow') }}</el-button>
          <el-button @click="resetForm">{{ $t('message.button.reset') }}</el-button>
          <el-button @click="breadcrumbClick" type="success">{{ $t("message.button.cancel") }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>

</template>

<style scoped>
.demo-ruleForm {
  width: 60%;
}

.add_form {
  padding: 15px 0;
  background: #fff;
}

.list-right {
  width: 72%;
  height: 740px;
  overflow: auto;
  padding: 0;
  float: left;
  border: 2px solid #ebebeb;
  margin: 0 0 0 16px;
}

.list-left {
  width: 25%;
  height: 740px;
  overflow: auto;
  padding: 0;
  border: 2px solid #ebebeb;
  float: left;
  position: relative;
  margin: 0;
}

.list-left li {
  padding: 6px;
}

.list-left li:hover {
  background: #5cb0f8;
  color: #fff;
}

.list-left-label {
  display: inline-block;
  width: 72%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
}

.isDisable {
  color: rgb(255, 11, 0);
}

.active {
  background: #5cb0f9;
  color: #fff;
}
</style>

<script>
import axios from "axios";
export default {
  name: "Lists",
  data() {
    return {
      updateInfo: 0,

      num: -1,
      activeDate: 1,
      listInfoShow: false,
      listEnabled: [],

      nameRule: [{ required: true, message: this.$t("message.warning.name") }],
      codeValueLengthRule: [{ required: true, message: this.$t("message.warning.name") }],
      input_width: {
        width: "50%",
      },
      search: "",
      basicData: [],
      listNames: [],
      createForm: {
        name: "",
        listType: "1",
        description: "",
        enabled: "1",
        codeValueLength: "",
        // displayType: "1",
      },
      addShow: false, //添加表格
      form: {
        name: "",
      },
      gridOptions: {
        keepSource: true,
        resizable: true,
        // border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "700",
        // rowConfig:{height: 120},
        // size: "small",
        columns: [
          {
            //   sortable: true,
            //   field: 'id',
            //   title: 'ID'
            // }, {
            sortable: true,
            field: "name",
            title: this.$t("message.table.name"),
          },
          {
            sortable: true,
            field: "description",
            title: this.$t("message.table.des"),
          },
          {
            sortable: true,
            field: "listType",
            title: this.$t("message.table.listType"),
            editRender: {
              name: "$select",
              options: [
                {
                  label: this.$t("message.table.simple"),
                  value: this.Constants.listTypeSimple,
                },
                {
                  label: this.$t("message.table.cascade"),
                  value: this.Constants.listTypeCascade,
                },
                {
                  label: this.$t("message.table.code"),
                  value: this.Constants.listTypeCode,
                },
                {
                  label: this.$t("message.table.serialNumber"),
                  value: this.Constants.listTypeSerialNumber,
                },
                {
                  label: this.$t("message.table.versionNumber"),
                  value: this.Constants.listTypeVersionNumber,
                },
                {
                  label: this.$t("message.table.reference"),
                  value: this.Constants.listTypeReference,
                },
                {
                  label: this.$t("message.table.dynamic"),
                  value: this.Constants.listTypeDynamic,
                },
              ],
            },
            // }, {
            //   sortable: true,
            //   field: 'displayType',
            //   title: this.$t('message.table.displayType'),
            //   editRender: {
            //     name: '$select',
            //     options: [{
            //       label: this.$t('message.table.list'),
            //       value: 1,
            //     }, {
            //       label: this.$t('message.table.search'),
            //       value: 2,
            //     }]
            //   },
          },
          {
            sortable: true,
            field: "enabled",
            title: this.$t("message.table.status"),
            editRender: {
              name: "$select",
              options: [
                {
                  label: this.$t("message.table.enabled"),
                  value: 1,
                },
                {
                  label: this.$t("message.table.disabled"),
                  value: 0,
                },
              ],
            },
          },
          {
            title: this.$t("message.table.actions"),
            width: 120,
            slots: {
              default: "operate",
            },
          },
        ],
        data: [],
        editConfig: {
          mode: "row",
          showIcon: false,
          showStatus: true,
        },
        sortConfig: {
          trigger: "cell",
        },
      },
      seekList: [],
    };
  },
  mounted() { },
  methods: {
    updateLists(val) {
      if (val) {
        this.getList()
      };
    },
    listSwitchChange(row, num) {
      console.log(row);
      // console.log(this.listEnabled[num].value);
      let obj = {};
      obj.id = row.id;
      obj.enabled = this.listEnabled[num].value ? 1 : 0;
      let vm = this;

      axios.post('/pmdm/admin/list/updateList', obj)
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            vm.$message({
              message: '切换成功！',
              type: 'success'
            });

            row.enabled = obj.enabled;
            this.activeDate += 1;
            this.$router.push({
              path: "/listInfo",
              query: { row: JSON.stringify(row), },
            });
          } else {
            this.listEnabled[num].value = !this.listEnabled[num].value;
            this.$message.error('切换失败，请重试');
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    filterNumberLength(e) {
      let n = isNaN(parseInt(this.createForm.codeValueLength)) ? 1 : parseInt(this.createForm.codeValueLength);
      let arr = (this.createForm.codeValueLength + '').split('');
      this.createForm.codeValueLength = n < arr.length ? arr.length : n;
    },
    breadcrumbClick() {
      this.addShow = false;
    },
    searchLists(e) {
      // console.log(e);
      // var val = e.trim()
      // console.log(val);
      if (!this.search || this.search == "*") {
        this.gridOptions.data = this.basicData;
        return;
      } else {
        let searchVal = [];
        console.log(e);
        this.basicData.forEach(item => {
          if (item.listTypeName.indexOf(this.search) !== -1) {
            searchVal.push(item);
          };
        });
        this.gridOptions.data = searchVal;
      };
      // axios
      //   .get("/pmdm/admin/list/searchList?name=" + this.search)
      //   .then((res) => {
      //     this.gridOptions.data = res.data.object.listEntities;
      //   })
      //   .catch(function (error) {
      //     //console.log(error);
      //   });
    },
    dbClick(row, index) {
      this.num = index;
      console.log(row);
      // this.$store.commit("setListId", row.row.id);
      this.$store.commit("setListId", row.id);
      //this.$router.push({path:"/listInfo",query:{row:row}});
      this.listInfoShow = true;
      this.activeDate += 1;

      // axios.get("/pmdm/admin/list/getList?id=105").then((res) => {
      //   console.log(res);
      //   })
      //   .catch(function (error) {
      //     //console.log(error);
      //   });

      this.$router.push({
        path: "/listInfo",
        query: { row: JSON.stringify(row), },
      });
    },
    submitForm() {
      this.createForm.name = this.createForm.name.trim();
      if (!this.createForm.name || this.createForm.name.match(/^[ ]*$/)) {
        this.$message.error(this.$t("message.error.name"));
        return false;
      };

      if (this.listNames.includes(this.createForm.name)) {
        this.$message.error(this.$t("message.error.nameUsed"));
        return;
      };

      // console.log(this.createForm.listType==4);
      // console.log(!this.createForm.codeValueLength);
      // console.log(this.createForm.name.match(/^[ ]*$/));
      if (this.createForm.listType == 4 && !this.createForm.codeValueLength) {
        this.$message.error(this.$t("message.error.codeValueLength"));
        return false;
      };
      axios
        .post("/pmdm/admin/list/saveList", this.createForm)
        .then((res) => {
          if (res.data.code == 200) {
            console.log(res);
            this.$message({
              type: "success",
              message: res.data.message,
            });
            this.$store.commit("setListId", res.data.object.id);
            this.getList();
            this.addShow = false;
            this.$router.push({
              path: "/listInfo",
              query: { row: JSON.stringify(this.createForm), },
            });
            this.$store.commit("setPageRefresh");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    resetForm() {
      this.createForm = {
        name: "",
        listType: "1",
        description: "",
        enabled: "1",
        // displayType: "1",
      };
    },
    addForm() {
      this.addShow = true;
      this.createForm = {
        name: "",
        listType: "1",
        description: "",
        enabled: "1",
        codeValueLength: "",
        // displayType: "1",
      };
    },
    getList() {
      this.input_width = this.Global.input_width_small;
      axios
        .get("/pmdm/admin/list/getAll")
        .then((res) => {
          //console.log(res);
          this.listEnabled = [];
          res.data.object.listEntities.forEach((item) => {
            let obj = {};
            obj.value = item.enabled == 0 ? false : true;
            obj.editable = item.editable == 0 ? false : true;
            this.listEnabled.push(obj);
          });
          //console.log(this.listEnabled);
          this.gridOptions.data = res.data.object.listEntities;
          var getListTypeName = '';
          for (let index = 0; index < this.gridOptions.data.length; index++) {
            if (this.gridOptions.data[index].listType == 1) {
              getListTypeName = this.$t("message.table.simple")
            } else if (this.gridOptions.data[index].listType == 2) {
              getListTypeName = this.$t("message.table.cascade")
            } else if (this.gridOptions.data[index].listType == 3) {
              getListTypeName = this.$t("message.table.dynamic")
            } else if (this.gridOptions.data[index].listType == 4) {
              getListTypeName = this.$t("message.table.code")
            } else if (this.gridOptions.data[index].listType == 5) {
              getListTypeName = this.$t("message.table.serialNumber")
            } else if (this.gridOptions.data[index].listType == 6) {
              getListTypeName = this.$t("message.table.versionNumber")
            } else if (this.gridOptions.data[index].listType == 7) {
              getListTypeName = this.$t("message.table.reference")
            } else {
              getListTypeName = ''
            }
            this.gridOptions.data[index].listTypeName = this.gridOptions.data[index].name + " -- " + getListTypeName;
          }
          console.log(this.gridOptions.data);
          this.basicData = this.deepCopy(res.data.object.listEntities);
          console.log(this.basicData);
          this.listNames = this.gridOptions.data.map((i) => {
            return i.name;
          });
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    removeRowEvent(row) {
      console.log(row);
      this.$confirm(
        this.$t("message.confirm.deleteList"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          var vm = this;
          axios
            .get("/pmdm/admin/list/deleteList?id=" + row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: res.data.message,
                });
                vm.getList();
              }
            })
            .catch(function (error) {
              //console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.deleteCancel"),
          });
        });
    },
    getListType(e) {
      console.log(e);
      if (e == 3 && !this.seekList.length) {
        axios.get('/pmdm/admin/criteria/getSeekList').then(res => {
          this.seekList = res.data.object.seekList.map(i => ({ label: i.name, value: i.id }))
        })
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>